import Content from '@/layout/content';
import Layout from '@/layout';

export default {
  path: '/track',
  component: window.name ? Content : Layout,
  redirect: '/track/monitor',
  meta: {
    title: '走航监控',
    icon: 'iconfont icon-nav',
    code: '010209'
  },
  children: [
    {
      path: 'monitor',
      name: 'taskMonitor',
      component: () => import('@/views/trackMonitor'),
      meta: {
        activeMenu: '/track'
      }
    },
    {
      path: '*',
      component: () => import('@/views/404')
    }
  ]
};
